// Automatically included by default on the backend
const { jQuery: $ } = window;
